export default "__VITE_ASSET__Dcb9ih6v__"